var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9828 2.72429C13.6948 3.1346 15.0467 4.09028 16.0373 5.44582C16.949 6.69343 17.4999 8.29275 17.4999 9.16667V13.3333C17.4999 14.5398 17.9602 15 19.1666 15V16.6667H13.3333C13.3333 18.5076 11.8409 20 9.99992 20C8.15897 20 6.66658 18.5076 6.66658 16.6667H0.833252V15C2.03968 15 2.49992 14.5398 2.49992 13.3333V9.16667C2.49992 8.29275 3.0508 6.69343 3.96251 5.44582C4.9531 4.09028 6.30501 3.1346 8.01704 2.72429C7.95182 2.52237 7.91658 2.30697 7.91658 2.08333C7.91658 0.93274 8.84932 0 9.99992 0C11.1505 0 12.0833 0.93274 12.0833 2.08333C12.0833 2.30697 12.048 2.52237 11.9828 2.72429ZM16.1552 15C15.9432 14.5336 15.8333 13.9754 15.8333 13.3333V9.16667C15.8333 8.65618 15.4001 7.39857 14.6917 6.42918C13.6486 5.00175 12.1251 4.16667 9.99992 4.16667C7.87475 4.16667 6.35128 5.00175 5.30816 6.42918C4.59976 7.39857 4.16659 8.65618 4.16659 9.16667V13.3333C4.16659 13.9754 4.05665 14.5336 3.84463 15H16.1552ZM9.99992 18.3333C9.07944 18.3333 8.33325 17.5871 8.33325 16.6667H11.6666C11.6666 17.5871 10.9204 18.3333 9.99992 18.3333Z",
    fill: "#DC1928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.a1892e2aaecd4d28974251a39a2ab3aa.svg";
export { ForwardRef as ReactComponent };